enum UserResume {
    UPDATE_RESUME = "Update Resume",
    SEARCH_SKILLS = "Search Skills"
  }
  
export default UserResume;